import { render, staticRenderFns } from "./solutionList.vue?vue&type=template&id=0790f048&scoped=true"
import script from "./solutionList.vue?vue&type=script&lang=js"
export * from "./solutionList.vue?vue&type=script&lang=js"
import style0 from "./solutionList.vue?vue&type=style&index=0&id=0790f048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0790f048",
  null
  
)

export default component.exports